module.exports = __webpack_public_path__ + "static/img/sr_chart.6fcdcf7.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/sr_chart.png
// module id = mCSf
// module chunks = 1